<template>
	<div class="system">
		<layout width="200px">
			<template v-slot:left>
				<publicMenu :list="list" iconUrl="list"></publicMenu>
			</template>
			<template v-slot:right>
				<router-view></router-view>
			</template>
		</layout>
	</div>
</template>

<script>
import layout from '../../components/layout.vue'
import publicMenu from '../../components/publicMenu.vue'

export default {

	data() {
		return {
			list: []
		}
	},
	components: {
		layout,
		publicMenu,
	},
	methods: {
		getAll() {
			console.log("11111")
			console.log("localStorage:", localStorage)
			let t = localStorage.getItem("cd");
			if (t) {
				var a = JSON.parse(t)
				a.forEach(val => {
					if (val.meta.title == '工作台') {
						var b = val.children
						this.list = b
					}
				})
				this.$router.push({
					name: this.list[0].children[1].meta.title
				})
			}
			console.log("22222")
			return
			this.$http.get(
				`/api/api/findMenusByRoleIdAndPath?path=${this.$route.matched[1].path}&roleId=${sessionStorage.roleId}`
			).then(res => {
				console.log(res)
				this.list = res.data.data;
				// this.$router.push(this.list[0].bdMenus[0].path);
			})
		}
	},
	mounted() {
		this.getAll();
	}
}
</script>

<style scoped="scoped">

</style>
